import React, {useEffect, useState} from 'react';
import Loading from '../Modals/Loading';
import {useNavigate} from 'react-router-dom';
import PayableService from "../Services/payableService";
import Head from '../Components/Head';

const Payable = () => {
    const [payables, setPayables] = useState([])
    const getPayables = async () => {
        try {
            const response = await PayableService.fetchAll()
            setPayables(response.payables)
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        getPayables()
    }, []);
    const clearCheck = async (id) => {
        PayableService.clear(id).then(res => {
            getPayables()
        })
    }
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate()
    return (
        <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
            {loading ?
                <Loading/> :
                <>
                  <Head heading={"PDC Payable"} button_text={"Add Payable"} navigation={() => navigate("/payable/add")}/>
                    {payables && payables.length > 0 ? (
                        <div className="table-div">
                        <table>
                            <thead>
                            <tr className=" uppercase leading-normal w-full text-white text-center">
                                <th className="pl-5 w-[4%] py-4 rounded-tl-lg">
                                    Customer Name
                                </th>
                                <th className="pl-5 w-[3%] py-4">
                                    Checque No
                                </th>
                                <th className="pl-5 w-[2%] py-4">
                                    Bank Name
                                </th>
                                <th className="pl-5 w-[2%] py-4">
                                    Amount
                                </th>
                                <th className="pl-5 w-[4%] py-4">
                                    Presentable Date
                                </th>
                                <th className="pl-5 w-[4%] py-4">
                                    Status
                                </th>
                                <th className="pl-5 w-[4%] py-4 rounded-tr-lg">
                                    Clear
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {payables.map((value, index) => (
                                <tr key={index}
                                    className="bg-accent hover:bg-gray-100 duration-300 border-b border-primary border-opacity-25 text-center">
                                    <td className="py-4 w-[2%]">
                                        {value.supplier_name}
                                    </td>
                                    <td className="py-4 w-[3%]">
                                        {value.number}
                                    </td>
                                    <td className="py-4 w-[3%]">
                                        {value.bank}
                                    </td>
                                    <td className="py-4 w-[3%]">
                                        {value.amount}
                                    </td>
                                    <td className="py-4 w-[3%]">
                                        {value.payable}
                                    </td>
                                    <td className="py-4 w-[3%]">
                                        <p
                                            className={`${value.status === "CLEARED" ? "bg-green-500" : "bg-red-500"} text-center rounded-md text-white uppercase`}>
                                            {value.status}
                                        </p>
                                    </td>
                                    <td className="py-4 w-[3%]">
                                        <button
                                            onClick={() => clearCheck(value.id)}
                                            className={`bg-primary text-center rounded-md text-white uppercase py-2 px-5`}>
                                            Clear Check
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                    ) : (
                        <div className="h-[75vh] flex justify-center items-center">
                            <h1 className="font-bold text-2xl text-gray-700 text-center">No Data Found</h1>
                        </div>
                    )}
                </>}
        </div>
    )
}
export default Payable
